import { createContext, useCallback, useContext, useState } from "react";

const SpaceCtx = createContext(null);

export const SpaceProvider = ({ children }) => {
  const [space, setSpaceState] = useState(() => (localStorage.getItem("fa-space") || "").startsWith("user:") ? localStorage.getItem("fa-space") : "all");
  const [version, setVersion] = useState(0);
  const [uploadOpen, setUploadOpen] = useState(false);
  const setSpace = useCallback((s) => {
    localStorage.setItem("fa-space", s);
    setSpaceState(s);
  }, []);
  const bump = useCallback(() => setVersion((v) => v + 1), []);
  return (
    <SpaceCtx.Provider value={{ space, setSpace, version, bump, uploadOpen, setUploadOpen }}>{children}</SpaceCtx.Provider>
  );
};

export const useSpace = () => useContext(SpaceCtx);
